




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { dateFormat } from '@/helpers/dateFormat';
import ArrayUtils from '@/helpers/arrayUtils';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import { addDays, parseStringToDate } from '@/helpers/dateUtils';

@Component({
  components: {
    DatePicker
  }
})
export default class UiDatePickerMultipleRange extends Vue {
  @Prop({
    default: ''
  })
  public label!: string;
  @Prop()
  public value!: any[];
  @Prop({
    default: null
  })
  public min?: string;
  @Prop({
    default: null
  })
  public max?: string;
  @Prop({
    default: null
  })
  public allowedDates?: string;
  @Prop({
    default: ''
  })
  public suffix?: string;
  @Prop({
    default: ''
  })
  public placeholder?: string;
  @Prop({
    default: ''
  })
  public height?: string;
  @Prop({
    default: false
  })
  public singleLine?: boolean;
  @Prop({
    default: false
  })
  public outline?: boolean;
  @Prop({
    default: false
  })
  public hideDetails?: boolean;
  @Prop({
    default: false
  })
  public required?: boolean;
  @Prop({
    default: () => []
  })
  public rules?: any[];
  @Prop({
    default: false
  })
  public clearable?: boolean;
  @Prop({
    default: false
  })
  public disabled?: boolean;
  @Prop()
  public prependInnerIcon?: string;
  @Prop({
    default: false
  })
  public onlyOneDate?: boolean; 
  @Prop({
    default: false
  })
  public loading: boolean;

  TYPE_RANGE = 'R';
  TYPE_MULTI = 'M';
  type = this.TYPE_MULTI;

  dateMenu: boolean = false;
  key = 0;

  daysRange: any = {};
  daysMulti = [];
  daysResult = [];
  daysShow = [];

  availableDates = [];
  fromDate = new Date();

  masksConfig = {
    title: 'MMMM "de" YYYY'
  };

  attrsRange = [
    {
      key: 'today',
      highlight: {
        fillMode: 'outline'
      },
      dates: new Date()
    }
  ];

  attributes() {
    let at = this.daysMulti.map((date) => ({
      key: 'sel',
      highlight: true,
      dates: date.date
    }));
    // exibir destaque do dia atual, somente se o dia não esta entre os escolhidos
    if (!this.daysMulti.filter((r) => r.date.toDateString() == new Date().toDateString()).length) {
      (at as any).splice(0, 0, {
        key: 'today',
        highlight: {
          fillMode: 'outline'
        },
        dates: new Date()
      });
    }
    return at;
  }

  public onChangeSeletedDatesRange(): void {
    if (!this.daysRange || !this.daysRange.start || !this.daysRange.end) {
      return;
    }

    // somente data
    this.daysRange.start = new Date(this.daysRange.start.toDateString());
    this.daysRange.end = new Date(this.daysRange.end.toDateString());

    this.daysResult = [];
    let day = this.daysRange.start;
    while (day <= this.daysRange.end) {
      this.daysResult.push(dateFormat(day, 'US', undefined, true));
      day = addDays(day, 1);
    }

    const calendar: any = this.$refs.calendarRange;
    calendar.move(this.daysRange.start);
    this.dateMenu = false;

    this.$emit('input', this.daysResult);
    this.$emit('change', this.daysResult);
  }

  onDayClick(day) {
    if (!this.dayAllowed(day.date)) {
      return;
    }
    if (this.onlyOneDate) {
      this.daysRange = [];
      this.daysMulti = [];
      this.daysResult = [];
    }
    this.key++;
    const idx = this.daysMulti.findIndex((d) => d.id === day.id);
    if (idx >= 0) {
      this.daysMulti.splice(idx, 1);
    } else {
      this.daysMulti.push({
        id: day.id,
        date: day.date
      });
    }
    this.daysShow = this.daysMulti.map((d) => {
      return dateFormat(d.date, 'BR', undefined, true);
    });
    this.daysResult = this.daysMulti.map((d) => {
      return dateFormat(d.date, 'US', undefined, true);
    });

    this.$emit('input', this.daysResult);
    this.$emit('change', this.daysResult);

    this.fromDate = day.date;
    if (this.onlyOneDate) {
      this.dateMenu = false;
    }
  }

  onTypeChange() {
    this.daysRange = [];
    this.daysMulti = [];
    this.daysResult = [];
    this.key++;
    this.$emit('input', this.daysResult);
    this.$emit('change', this.daysResult);
  }

  @Watch('value')
  public onChangeValue(dates: string[]): void {
    if (dates && dates.length == 1) {
      this.type = this.TYPE_MULTI;
    }
    this.key++;
    this.daysResult = dates;
    this.daysMulti = dates.map((d) => {
      return { id: d, date: parseStringToDate(d, 'YYYY-MM-DD') };
    });

    this.daysShow = dates.map((d) => this.formatDate(d));
  }

  private formatDate(date: string): string {
    return !date ? '' : dateFormat(date, 'BR', undefined, true);
  }

  allowedDatesOld = [];

  @Watch('allowedDates')
  public onAllowedDatesChange(dates) {
    if (ArrayUtils.equalsIgnoreOrder(dates, this.allowedDatesOld)) {
      return;
    }
    this.allowedDatesOld = dates;
    if (!dates || !dates.length) {
      this.availableDates = null;
      return;
    }
    dates.sort((d1, d2) => (d1 < d2 ? -1 : 1));
    this.availableDates = [];
    for (let i = 0; i < dates.length; i++) {
      let dIni = parseStringToDate(dates[i], 'YYYY-MM-DD');
      let dEnd = parseStringToDate(dates[i], 'YYYY-MM-DD');
      while (
        i + 1 < dates.length &&
        addDays(dEnd, 1).getTime() == parseStringToDate(dates[i + 1], 'YYYY-MM-DD').getTime()
      ) {
        dEnd = parseStringToDate(dates[++i], 'YYYY-MM-DD');
      }
      (this.availableDates as any).push({ start: dIni, end: dEnd });
    }
  }

  onComboChange() {
    this.daysResult = this.daysShow.map((d) => {
      return dateFormat(d, 'US', 'DD/MM/YYYY', true);
    });
    this.type = this.TYPE_MULTI;
    this.key++;
    this.dateMenu = false;
    this.$emit('input', this.daysResult);
    this.$emit('change', this.daysResult);
  }

  dayAllowed(d) {
    if (!this.allowedDates || !this.allowedDates.length) {
      return true;
    }
    return this.allowedDates.indexOf(dateFormat(d, 'US', null, true)) >= 0;
  }
}
